import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LoginGuard implements CanActivate {
  constructor(
    private route: Router
  ) { }

  canActivate(): boolean {
    if (!localStorage.getItem("access_token")) {
      return true;
    } else {
      this.route.navigateByUrl("");
      return false;
    }
  }

  canLoad(): Observable<boolean> | boolean {
    if (!localStorage.getItem("access_token")) {
      return true;
    } else {
      this.route.navigateByUrl("");
      return false;
    }
  }
}
